module.exports = __webpack_public_path__ + "static/media/cq_inoltra.dc5275db.svg";